<div>
    <h6 class="text-secondary fw-bold">Novedad en la solicitud de servicio</h6>

    <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
        <br>
        <div class="overflow-auto">
            <table class="table table-bordered text-center">
                <thead>
                    <tr>
                        <th scope="col">ID solicitud</th>
                        <th scope="col">Referente que solicitó el servicio</th>
                        <th scope="col">Fecha de la novedad</th>
                        <th scope="col">Nombre del Directivo</th>
                        <th scope="col">Motivo de la novedad</th>
                        <th scope="col">Justificación</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of dataTable">
                        <td>{{data.solicitudId}}</td>
                        <td>{{data.vcNombreReferente}}</td>
                        <td>{{data.dtFechaNovedad}}</td>
                        <td>{{data.vcNombreDirectivo}}</td>
                        <td>{{data.vcMotivoNovedad}}</td>
                        <td>{{data.txJustificacion}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>